<!-- 
this component should be ONLY be used to toggle hidden questions
when a radio button is pressed an action is dispatched with the question instance as the payload
 -->
<template>
  <div>
    <HomeBaseLabel :question="question" />
    <v-radio-group
      hide-details="auto"
      v-model="question.Value"
      @change="setQuestionVisibility(question)"
    >
      <v-radio
        v-for="(option, index) in question.Options"
        :key="index"
        :label="option.Text"
        :value="option.Value"
      ></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";

export default {
  name: "RadioBaseToggleHiddenQuestion",
  components: {
    HomeBaseLabel,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, ["setQuestionVisibility"]),
  },
};
</script>

<style lang="scss" scoped></style>
